import { createSlice } from '@reduxjs/toolkit';
import { WebhooksListStateType } from 'src/types/webhooksList';

const initialState: WebhooksListStateType = {
    data: null,
    loading: false,
    error: false,
};

export const webhooksListSlice = createSlice({
    name: 'webhooksList',
    initialState,
    reducers: {
        getWebhooksListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getWebhooksListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getWebhooksListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getWebhooksListFetch, getWebhooksListFetchSuccess, getWebhooksListFetchFailure } =
    webhooksListSlice.actions;

export default webhooksListSlice.reducer;
